<template>
  <div id="create">
    <div data-dial-init id="speed-dial" @mouseleave="onLeave">
      <div v-if="showMenu" id="speed-dial-menu-default" class="items-center mb-4 space-y-2">
        <div v-for="btn in secondaryButtons" :key="btn.name" class="btnContainer m-auto">
          <base-button-icon :name="btn.name" :mode="mode" :iconSize="secondaryIconSize" :size="secondarySize"
            :loading="btn.loading" :custom="custom" @click="doAction(btn)" />
        </div>
      </div>
      <div class="btnContainer">
        <base-button-icon data-dial-toggle="speed-dial-menu-default" aria-controls="speed-dial-menu-default"
          aria-expanded="false" :name="name" :mode="mode" :iconSize="mainIconSize" :size="mainSize"
          :custom="custom" @mouseenter="onEnter" @click="onClick" />
      </div>
    </div>
  </div>
</template>
<script>
import { i18n } from '@/i18n'
export default {
  name: 'base-dropdown-floating-button',
  props: {
    hover: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'primary-phantom',
    },
    custom: {
      type: [String, Object],
      default: undefined,
    },
    mainIcon: {
      type: String,
      default: 'plus',
    },
    mainIconSize: {
      type: String,
      default: 'lg',
    },
    mainSize: {
      type: String,
      default: 'xl',
    },
    secondaryIconSize: {
      type: String,
      default: 'sm',
    },
    secondarySize: {
      type: String,
      default: 'md',
    },
    secondaryButtons: {
      type: Array,
      default: () => [{
        name: 'sede',
        custom: undefined,
        listener: () => console.log(i18n.t('app.sec_button_clicked')),
        loading: false,
      }],
    },
  },
  data: () => ({
    showMenu: false,
  }),
  computed: {
    name: function () {
      return this.showMenu ? 'cross' : 'plus'
    }
  },
  methods: {
    onEnter: function () {
      if (this.hover) {
        this.showMenu = true
      }
    },
    onLeave: function () {
      if (this.hover) {
        this.showMenu = false
      }
    },
    onClick: function () {
      if (!this.hover) {
        this.showMenu = !this.showMenu
      }
    },
    doAction: function (btn) {
      btn.loading = true
      btn.listener()
      btn.loading = false
      this.showMenu = false
    }
  },
}
</script>
<style scoped>
/* This is for documentation purposes and will not be needed in your application */
#create #speed-dial {
  position: absolute;
  right: 2%;
  bottom: 10%;
}

#create .btnContainer {
  position: relative;
}
</style>
